import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_STAFF,
  GET_STAFFS,
  GET_STAFFS_DDL,
  GET_STAFFS_BY_FILTER,
  ADD_STAFF,
  UPDATE_STAFF,
  DELETE_STAFF,
} from '@/queries/modules/profile/staff';

export async function getStaffs(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STAFFS,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      // context.commit('setStaffs', data.getStaffs);
      context.commit('setSuccess', null);
      return data.getStaffs
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStaffsDdl(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STAFFS_DDL,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStaffsDdl', data.getStaffs);
      context.commit('setSuccess', null);
      return data.getStaffs
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStaffsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STAFFS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStaffs', data.getStaffsByFilter);
      context.commit('setSuccess', null);

      return data.getStaffsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStaff(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STAFF,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      // context.commit('setStaff', data.getStaff);
      context.commit('setSuccess', null);
      return data.getStaff
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addStaff(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_STAFF,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const staffs = [...context.state.staffs];
      staffs.push(data.addStaff);
      context.commit('setStaffs', staffs);
      context.commit('setSuccess', newItemSuccess(data.addStaff.code));

      return data.addStaff
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateStaff(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_STAFF,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.staffs.findIndex(item => item.id === data.updateStaff.id);
      const staffs = [
        ...context.state.staffs.slice(0, index),
        data.updateStaff,
        ...context.state.staffs.slice(index + 1)
      ];
      context.commit('setStaffs', staffs);
      context.commit('setSuccess', updateItemSuccess(data.updateStaff.code));

      return data.updateStaff
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteStaff(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_STAFF,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.staffs.findIndex(item => item.id === data.deleteStaff.id);
      const staffs = [
        ...context.state.staffs.slice(0, index),
        ...context.state.staffs.slice(index + 1)
      ];
      context.commit('setStaffs', staffs);
      context.commit('setSuccess', deleteItemSuccess(data.deleteStaff.code));

      return data.deleteStaff
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}
